import { Flex, Select, Typography } from 'antd';
import clsx from 'clsx';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getFullName } from '../../../utils';

const { Option } = Select;

const SalesRepFilter = ({
    size = 'large',
    placeholder = 'Search Sales Rep',
    onChange,
    value,
    isNetsuiteId = false,
    className,
    filedSaleRepOnly = false,
    ...props
}) => {
    const { salesReps } = useSelector((state) => state.usersSlice);

    const users = useMemo(() => {
        if (!filedSaleRepOnly) return salesReps;

        return salesReps.filter((u) => u?.type === 2);
    }, [salesReps, filedSaleRepOnly]);

    const normalizedValue = useMemo(() => {
        if (!value) return undefined;

        if (typeof value === 'object') {
            return value;
        }

        const user = users.find(
            (u) =>
                (isNetsuiteId ? u?.netsuite_id : u?.id) === parseInt(value)
        );

        if (!user) return undefined;

        return {
            value: parseInt(value),
            label: getFullName(user),
        };
    }, [value, users, isNetsuiteId]);

    return (
        <Select
            className={clsx(className ?? "lg:max-w-20rem w-full")}
            size={size}
            placeholder={placeholder}
            optionLabelProp="label"
            showSearch
            optionFilterProp="label"
            allowClear
            filterOption={(input, option) =>
                String(option['data-title'] || '')
                    .toLowerCase()
                    .includes(input.toLowerCase()) ||
                String(option['data-code'] || '')
                    .toLowerCase()
                    .includes(input.toLowerCase())
            }
            value={normalizedValue}
            onChange={onChange}
            {...props}
        >
            {users?.map((user) => (
                <Option
                    key={isNetsuiteId ? user?.netsuite_id : user?.id}
                    value={isNetsuiteId ? user?.netsuite_id : user?.id}
                    label={getFullName(user)}
                    data-code={user?.email}
                    data-title={getFullName(user)}
                >
                    <Flex vertical gap={1}>
                        <Typography.Text>{getFullName(user)}</Typography.Text>
                        <Typography.Text type="secondary">{user.email}</Typography.Text>
                    </Flex>
                </Option>
            ))}
        </Select>
    );
};

export default SalesRepFilter;
